import script from "./ServiceIconMixin.vue?vue&type=script&lang=js"
export * from "./ServiceIconMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__